<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "RelationCreated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.relationCreated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                relationName: this.$_.get(this.activity, 'payload.displayName')
            });
        }
    }
};
</script>


